"use client";
import { jsx as s, jsxs as i } from "react/jsx-runtime";
import o from "clsx";
import k from "next/image";
import { memo as w, forwardRef as b, useState as E, useEffect as v } from "react";
import { Box as l } from "../../base/Base.js";
import { s as e } from "../../../UploadedPhotoBlock.module-NQCKFqNv.js";
const B = ({
  src: m,
  blur: u,
  loader: p,
  processing: d,
  type: n,
  project: r,
  onReset: h,
  videoRef: t,
  hidePlayIcon: N,
  children: P
}, _) => {
  const [g, c] = E(!1);
  v(() => {
    const a = t == null ? void 0 : t.current;
    if (!a) return;
    const f = () => c(!0), y = () => c(!1);
    return a.addEventListener("play", f), a.addEventListener("pause", y), c(!a.paused), () => {
      a.removeEventListener("play", f), a.removeEventListener("pause", y);
    };
  }, []);
  const x = () => {
    const a = t == null ? void 0 : t.current;
    a && (a.paused ? a.play() : a.pause());
  };
  return /* @__PURE__ */ s(l, { gap: 0, className: e.photo_block, ref: _, children: /* @__PURE__ */ i(l, { gap: 0, className: e.photo_inner, children: [
    /* @__PURE__ */ i("div", { className: e.photo_box, children: [
      n === "image" && /* @__PURE__ */ s(
        k,
        {
          src: m,
          alt: "image",
          fill: !0,
          className: o(e.content, { [e.blur]: u }),
          style: { width: "100%" },
          unoptimized: !0
        }
      ),
      n === "video" && /* @__PURE__ */ s(
        "video",
        {
          ref: t,
          autoPlay: !0,
          loop: !0,
          muted: !0,
          className: o(e.content, { [e.blur]: u }),
          children: /* @__PURE__ */ s("source", { src: m })
        }
      ),
      p && d && /* @__PURE__ */ s(l, { className: e.loader, children: p }),
      h && /* @__PURE__ */ s(
        "div",
        {
          className: o(e[r], {
            [e.refresh_photo]: r !== "swaperface",
            [e.refresh_video]: r === "swaperface"
          }),
          onClick: h,
          children: /* @__PURE__ */ s(
            "span",
            {
              className: "material-icons",
              "data-icon": r === "swaperface" || r === "clothoff" ? "delete" : "autorenew"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ i(l, { center: !0, className: e.banner_box, children: [
      n === "video" && !d && !N && /* @__PURE__ */ s(
        l,
        {
          center: !0,
          className: o("material-icons", e.play_icon),
          "data-icon": g ? "pause_circle" : "play_circle",
          onClick: x
        }
      ),
      P
    ] })
  ] }) });
}, L = w(
  b(
    B
  )
);
L.displayName = "UploadedPhotoBlock";
export {
  B as InternalUploadedPhotoBlock,
  L as UploadedPhotoBlock
};
